<template>
    <div>
        <div id="login-container" class="container">
            <img src="../../assets/img/oskar-plain.svg" id="codelab-bee" />
            <div id="login-form-container">
                <b-form-group label="Password" :label-cols-md="2" :label-cols="12" :horizontal="true">
                    <b-row>
                        <b-col md="12"
                            ><b-form-input
                                v-model="$v.password.$model"
                                type="password"
                                placeholder="Enter the Codelab Password"
                            ></b-form-input>
                        </b-col>
                    </b-row>
                </b-form-group>
                <Feedback :state="loginError.state" :invalid="loginError.message"></Feedback>
                <b-button @click="login" :disabled="$v.password.$invalid" variant="secondary" id="btn-submit-password">
                    Submit
                </b-button>
            </div>
        </div>
        <Loading :loading="$store.state.loading.processing" :text="$store.state.loading.text"></Loading>
    </div>
</template>

<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'

import Feedback from '@/components/Feedback'
import Loading from '@/components/loading'

export default {
    components: {Feedback, Loading},
    data() {
        return {
            password: '',
            loginError: {
                state: null,
                message: null,
            },
        }
    },
    mixins: [validationMixin],
    validations: {
        password: {required},
    },
    methods: {
        async login() {
            this.$store.commit('loading/PROCESSING', `Authenticating...`)
            try {
                const response = await this.axios.post(
                    `${process.env.VUE_APP_NODE_API_HOST}/codelabs/auth/${this.$route.params.id}`,
                    {password: this.password}
                )
                this.loginError.state = true
                this.loginError.message = null
                const {token} = response.data.data
                this.$store.commit('loading/PROCESSED')

                const {redirectedFrom, ...queryParams} = this.$route.query
                const queryEntries = Object.entries(queryParams)
                    .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
                    .join('&')

                if (process.env.VUE_APP_MODE === 'local') {
                    window.location = `http://localhost:4000/${this.$route.params.id}?t=${encodeURIComponent(
                        token
                    )}&${queryEntries}`
                } else {
                    window.location = `https://${this.$route.query.redirectedFrom}/${
                        this.$route.params.id
                    }?t=${encodeURIComponent(token)}${queryEntries ? `&${queryEntries}` : ''}`
                }
            } catch (e) {
                this.loginError.state = false
                this.loginError.message = e.response.data ? e.response.data : 'Could not log in'
                this.$store.commit('loading/PROCESSED')
            }
        },
    },
}
</script>

<style lang="scss">
#login-container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
#codelab-bee {
    width: 8rem;
    margin: 1rem auto;
    display: block;
}
#login-form-container {
    background: white;
    border-radius: 5px;
    box-shadow: 10px 9px 26px -15px rgba(0, 0, 0, 0.75);
    padding: 2rem;
}
#btn-submit-password {
    margin: 1rem auto;
    display: block;
}
</style>
